// DeviceType Templates Index
// Each device type has its own template folder with numbered variants

import React from 'react';

// Template exports
export * as Dehumidifier from './Dehumidifier';
export { DehumidifierTemplates } from './Dehumidifier';

export * as Switch from './Switch';
export { SwitchTemplates } from './Switch';

export * as Sensor from './Sensor';
export { SensorTemplates } from './Sensor';

export * as Light from './Light';
export { LightTemplates } from './Light';

export * as Generic from './Generic';
export { GenericTemplates } from './Generic';

export * as Hvac from './Hvac';
export { HvacTemplates } from './Hvac';

export * as Fan from './Fan';
export { FanTemplates } from './Fan';

// New templates
export * as Curtain from './Curtain';
export { CurtainTemplates } from './Curtain';

export * as Blind from './Blind';
export { BlindTemplates } from './Blind';

export * as PowerMeter from './PowerMeter';
export { PowerMeterTemplates } from './PowerMeter';

export * as PowerMeter3Phase from './PowerMeter3Phase';
export { PowerMeter3PhaseStyles } from './PowerMeter3Phase';

export * as DoorSensor from './DoorSensor';
export { DoorSensorTemplates } from './DoorSensor';

export * as Button from './Button';
export { ButtonTemplates } from './Button';

export * as Erv from './Erv';
export { ErvTemplates } from './Erv';

// Template type
export type DeviceType = 'dehumidifier' | 'switch' | 'th_sensor' | 'presence_sensor' | 'lux_sensor' | 'light' | 'hvac' | 'fan' | 'blind' | 'curtain' | 'door_sensor' | 'power_meter' | 'power_meter_3phase' | 'button' | 'outlet' | 'bridge' | 'controller' | 'erv' | string;

// Template selector function - returns Promise<{ default: ComponentType }>
export function getTemplateForDeviceType(deviceType: DeviceType): Promise<{ default: React.ComponentType<any> }> {
  switch (deviceType) {
    case 'dehumidifier':
      return import('./Dehumidifier');
    case 'switch':
    case 'outlet':
      return import('./Switch');
    case 'th_sensor':
    case 'presence_sensor':
    case 'lux_sensor':
    case 'multi_sensor':
      return import('./Sensor');
    case 'light':
      return import('./Light');
    case 'hvac':
      return import('./Hvac');
    case 'fan':
      return import('./Fan');
    case 'erv':
      // ERV (Energy Recovery Ventilator) - 全熱交換器專用模板
      return import('./Erv');
    case 'curtain':
      return import('./Curtain');
    case 'blind':
      return import('./Blind');
    case 'power_meter':
      return import('./PowerMeter');
    case 'power_meter_3phase':
      return import('./PowerMeter3Phase');
    case 'door_sensor':
      return import('./DoorSensor');
    case 'button':
      return import('./Button');
    default:
      return import('./Generic');
  }
}
